import React, { useState, useEffect } from 'react';
import { Button, Modal, Spin, Divider, Collapse, Progress } from 'antd';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { CopyTwoTone } from '@ant-design/icons'
import AdsComponent from './AdsComponent';
import uploadFile from '../../../helpers/s3-upload';

import videoFile from '../../../assets/ads/svgtracepro.mov';
import manualservice from '../../../assets/ads/manualservice.png';
import { set } from 'react-ga';



// import collectData from '../../../helpers/collect-data';
// const uuid = require('uuid');

const { Panel } = Collapse;

const ResultsModal = (props) => {

  const [shareLinkText, setShareLinkText] = useState("Click To Create Share Link");
  const [shareLink, setShareLink] = useState('');
  const [timer, setTimer] = useState(null);

  const [timerDone, setTimerDone] = useState(false);
  const [skipAd, setSkipAd] = useState(true);
  const [showAd, setShowAd] = useState(-1);


  // make a useEfeect to set the timer for 5 seconds
  useEffect(() => {

    if (timer) {
      clearTimeout(timer);
      // setTimerDone(false);
    }


    if (Math.random() > 0.8) {
      setShowAd(1)
        setTimer(setTimeout(() => {
        console.log('timer done');
        setTimerDone(true);
      }, 5000));
      setSkipAd(false);
    }

    // if (Math.random() > 0.5) setShowAd(true);
    // else setShowAd(false);

    // if (Math.random() > 0.5) {
    //   setShowAd(1)
    //   setTimer(setTimeout(() => {
    //     console.log('timer done');
    //     setTimerDone(true);
    //   }, 5000));
    // }
    // else {
    //   setShowAd(2);
    //   setTimerDone(true);
    // }
  }, []);

  const handleOk = async function () {

    // // if item from storage doesnt exist, create a new user id
    // if (!JSON.parse(localStorage.getItem('svgTraceUserId'))) {
    //   const userId = uuid.v4()
    //   localStorage.setItem('svgTraceUserId', JSON.stringify(userId))
    // }





    // let deviceType = 'desktop';
    // // if navigator is iphone set device type to iPhone
    // if (navigator.userAgent.match(/iPhone/i) ) deviceType = 'iPhone';
    // else if (navigator.userAgent.match(/Android/i) ) deviceType = 'android';
    // else if (navigator.userAgent.match(/iPad/i) ) deviceType = 'iPad';
    // else if (navigator.userAgent.match(/iPod/i) ) deviceType = 'iPod';
    // else if (navigator.userAgent.match(/BlackBerry/i) ) deviceType = 'blackberry';
    // else if (navigator.userAgent.match(/Windows Phone/i) ) deviceType = 'windows phone';
    // else if (navigator.userAgent.match(/Windows/i) ) deviceType = 'windows';
    // else if (navigator.userAgent.match(/Linux/i) ) deviceType = 'linux';
    // else if (navigator.userAgent.match(/Mac/i) ) deviceType = 'mac';
    // else deviceType = 'other';



    // collectData(blob, `users/${JSON.parse(localStorage.getItem('svgTraceUserId'))}/downloads`, deviceType);

    // get lastConverted from session storage
    // let lastConverted = sessionStorage.getItem('lastConverted');
    // console.log(lastConverted);


    let blob = await fetch(props.downloadSVGLink).then(r => r.blob());
    uploadFile(blob, "svgtrace-downloads-bucket", "svg-converter/",)


    // console.log("link clicked");
    const link = document.createElement('a');
    link.href = props.downloadSVGLink;
    link.setAttribute(
      'download',
      `trace.svg`,
    );
    // Append to html link element page
    document.body.appendChild(link);
    // Start download
    link.click();
    // Clean up and remove the link
    link.parentNode.removeChild(link);
    // props.setIsModalVisible(false)

  }
  const handleCopy = async function () {
    // if share link doesnt exist, create a new share link
    if (shareLink === '') {
      let blob = await fetch(props.downloadSVGLink).then(r => r.blob());
      const newSharelink = await uploadFile(blob, "svgtrace-upload-results-bucket")
      setShareLink(newSharelink);
      // await navigator.clipboard.writeText(newSharelink);
      setShareLinkText("Click to Copy");
      return;
    }
    // copy new value to clipboard
    navigator.clipboard.writeText(shareLink);
    setShareLinkText("Share Link Copied");
    // let blob = await fetch(props.downloadSVGLink).then(r => r.blob());
    // collectData(blob, "image-to-svg/share-link-copied");
  }

  // check for state change of sharLink and copy to clipboard
  useEffect(() => {
    if (shareLink !== '') {
      handleCopy();
    }
  }, [shareLink])




  // // make a function that returns two different buttons depending on what the shareLink is
  // const shareLinkButton = () => {
  //   if (shareLink === '') {
  //     return (

  //       <Button>{copied ? 'Share Link Copied ' : 'Share Link '}</Button>

  //     )
  //   } else {
  //     return (
  //       <CopyToClipboard text={shareLink}
  //       onCopy={() => {handleCopy();} }>
  //       <Button icon={<CopyTwoTone/>}>{copied ? 'Share Link Copied ' : 'Share Link '}</Button>
  //     </CopyToClipboard>
  //     )
  //   }
  // }

  // isIOS variable
  const isIOS = () => {
    // make 50/50 chance of returning true or false
    // console.log(Math.random());
    return showAd;

    // // return true if user agent is iphone
    // if (navigator.userAgent.match(/iPhone/i)) return true;
    // else if (navigator.userAgent.match(/iPad/i)) return true;
    // else if (navigator.userAgent.match(/iPod/i)) return true;
    // else return false;
  }

  const handleCancel = () => {
    props.setIsModalVisible(false)
  }

  return (
    // set the max height of the modal to 80% of the screen

    <Modal
      title={!props.isLoading && skipAd ? 'Preview' : ''}
      open={true}
      onOk={() => { handleOk(); }}
      onCancel={() => { handleCancel(); }}
      footer=
      // if  !props.isLoading && timerDone
      // show the buttons
      // else show the ad

      {!props.isLoading && skipAd ?
        [
          <Button key="back" onClick={() => { handleCancel(); }} >
            Cancel
          </Button>,
          <CopyToClipboard
            text={shareLink}
            onCopy={() => { handleCopy(); }
            }>
            <Button icon={<CopyTwoTone />}>{shareLink != "" ? 'Share Link Copied' : 'Copy Share Link '}</Button>
          </CopyToClipboard>,
          <Button key="downloadSVG" loading={props.isLoading} onClick={() => { handleOk(); }} >
            Download SVG
          </Button>
          ,
        ] : [
          // center the button
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%" }}>


            <Button type="link" onClick={() => setSkipAd(true)} loading={!(!props.isLoading && timerDone) ? true : false}>
              {!(!props.isLoading && timerDone) ? "Converting" : "No thanks, take me to the download screen"}
            </Button>
          </div>


        ]}

    >
      {/* check to see if the timer is done */}

      {/* make a minimum 5 second ad  or until is loading is finished*/}
      {!(!props.isLoading && skipAd) ?
        // if the user is on iOS
        // show the ad
        // else show the video
        <div>
          {showAd === 1 &&
            <>
              <h3>Want to edit your SVG?</h3>
         
      
              <video autoPlay={true} playsInline={true} loop={true} style={{ width: "100%" }}>
                <source src={videoFile} type="video/mp4" />
              </video>     
              <div style={{ height: "10px" }}></div>

              <Button type="primary" onClick={() => {
                // navigate to https://apps.apple.com/ca/app/svgtrace-pro/id6444320997 in a new tab
                window.open("https://apps.apple.com/ca/app/svgtrace-pro/id6444320997", "_blank")
              }} style={{ width: "100%" }}>
                Download SvgTrace Pro for iOS
              </Button>
            </>
          }
          {showAd  === 2&&
            // make a spacer
            <>
              <h3>Need more help? We will trace any image within 48 hours.</h3>
              {/* <div style={{ height: "30px" }}></div> */}
              <img src={manualservice} style={{
                maxWidth: "70%",
                // center 
                display: "block",
                marginLeft: "auto",
                marginRight: "auto"
              }} />
              <div style={{ height: "20px" }}></div>

              <Button type="primary" onClick={() => {
                // navigate to https://apps.apple.com/ca/app/svgtrace-pro/id6444320997 in a new tab
                window.open("http://192.168.86.238:8080/services/manual-svg-conversion", "_blank")
              }} style={{ width: "100%" }}>
                Learn More
              </Button>

            </>



          }
        </div>

        :
        <div>


          <img id="preview" width={"100%"} src={props.downloadSVGLink} />


          <Divider style={{ margin: '0px', marginTop: '20px', marginBottom: '10px' }} />
          <Collapse >
            {/* <Panel header="Seeing Little Unwanted Dots?" key="1">
              <p>Try turning up the Despeckle slider.</p>
            </Panel>
            <Panel header="Seeing Jagged Edges?" key="2">
              <p>Try turning up the smoothness slider.</p>
            </Panel> */}
            <Panel header="Want to Edit the SVG?" key="3">
              <p>Download <a href="https://apps.apple.com/ca/app/svgtrace-pro/id6444320997" target="_blank" rel="noopener noreferrer">SvgTrace Pro</a> on iOS to easily adjust the modify the converted SVG file.</p>
            </Panel>
            <Panel header="Want to Bulk Convert SVGs?" key="4">
              <p>Download <a href="https://apps.apple.com/ca/app/svgtrace-pro/id6444320997" target="_blank" rel="noopener noreferrer">SvgTrace Pro</a> on iOS to easily adjust the modify the converted SVG file.</p>
            </Panel>

          </Collapse>
          {/* <p style={{ paddingTop: "10px" }}>Need an SVG specialist to convert it manually? </p>
          <a href='https://transactions.sendowl.com/products/78704636/EE973E75/view'>
            <Button type="primary" block>
              Manual Conversion Service
            </Button>
          </a> */}
          {/* </Spin> */}
        </div>


      }


    </Modal>
  );
};

export default ResultsModal;
